import React, { Component } from 'react';
// import '../../App.css';
import { connect } from 'react-redux';
import { BrowserRouter as Router,Route,Link} from 'react-router-dom';
import { withRouter } from 'react-router';
const styles = {}
class EditTiersSection extends Component{
    render() {
        return(
            <div className="white-wrap" id="edittiers">
                <div className="">
                    <div className="large-12 columns">
                        <h5 className="text-center">EDIT-TIERS™</h5>
                        <div style={{height:'32px'}}></div>
                    </div>
                    <div className="orange-blurb popup2" tabIndex="1" style={{"position":"fixed","zIndex":"999","top":"0px","left":"0px","maxWidth":"90%","maxHeight":"95%","overflow":"auto","width":"600px","display":"none"}}>
                        <p className="text-right"><a className="close-popup2">X</a></p>
                        <p><strong>Silver editors are capable of editing most documents and specialize in non-ESL document editing. Your editor will provide you with limited comments on how you can improve particular parts of your paper, if required.</strong></p>
                    </div>
                    <div className="orange-blurb popup2" tabIndex="2" style={{"position":"fixed","zIndex":"999","top":"0px","left":"0px","maxWidth":"90%","maxHeight":"95%","overflow":"auto","width":"600px","display":"none"}}>
                        <p className="text-right"><a className="close-popup2">X</a></p>
                        <p><strong>Specializing in ESL editing, Gold editors are the cream of the crop, which means they are chosen because of their ability to correct your English to make it read perfectly and tend to make the most edits to documents. They'll correct your spelling, grammar, word choice, flow, consistency, run-on sentences, sentence fragments, and punctuation. Your editor will provide comments to guide you through any necessary improvements. Due to a Gold editor's higher education and proven editing ability, they truly excel when editing professional documents, dissertations, theses, academic journals, and all other English written works. Remember, Gold editors don't just proofread your paper, they thoroughly edit it until it reads perfectly!</strong></p>
                    </div>
                    <div className="orange-blurb popup2" tabIndex="3" style={{"position":"fixed","zIndex":"999","top":"0px","left":"0px","maxWidth":"90%","maxHeight":"95%","overflow":"auto","width":"600px","display":"none"}}>
                        <p className="text-right"><a className="close-popup2">X</a></p>
                        <p><strong>Bronze editors are knowledgeable on a variety of subjects and specialize in proofreading and lightly editing your final draft or a non-ESL document. They have an eye for detail and catch what you may have missed.</strong></p>
                    </div>
                    <div className="tier" style={{float: 'left'}}>
                        <center>
                            <img src="images/tiers/silver1.png" className="hoverOpt2" tabIndex="1"/>
                            <br /><br/>
                            <h2>Silver gives you access to</h2>
                        </center>
                        <h3>
                            <img src="images/home/checkmark.png" style={{width:'24px'}}/> Experienced teachers
                        </h3>
                        <h3>
                            <img src="images/home/checkmark.png" style={{width:'24px'}}/> University graduates or master students
                        </h3>
                        <h3>
                            <img src="images/home/checkmark.png" style={{width:'24px'}}/> Perfect for second drafts or short assignments
                        </h3>
                        <h2>From $8/page (325 words)</h2>
                        <a href="/get-started">
                            <div className="get-started-btn get-started-blue get-started-small text-center large-12">
                                EDIT MY PAPER NOW!
                            </div>
                        </a>
                    </div>
                    <div className="tier" style={{float: 'left'}}>
                        <center>
                            <img src="images/tiers/gold1.png" className="hoverOpt2" tabIndex="2"/>
                            <br/><br/>
                            <h2>Gold gives you access to</h2>
                        </center>
                        <h3>
                            <img src="images/home/checkmark.png" style={{width:'24px'}}/> Experienced professors
                        </h3>
                        <h3>
                            <img src="images/home/checkmark.png" style={{width:'24px'}}/> Teaching assistants or professional-level editors
                        </h3>
                        <h3>
                            <img src="images/home/checkmark.png" style={{width:'24px'}}/> Perfect for term assignments, ESL students or rough essays
                        </h3>
                        <h2>From $9.50/page (325 words)</h2>
                        <a href="/get-started">
                            <div className="get-started-btn get-started-blue get-started-small text-center large-12">
                            EDIT MY PAPER NOW!
                            </div>
                        </a>
                    </div>
                    <div className="tier" style={{float: 'left'}}>
                        <center>
                            <img src="images/tiers/bronze1.png" className="hoverOpt2" tabIndex="3" height="234"/>
                            <br /><br />
                            <h2>Bronze gives you access to</h2>
                        </center>
                        <h3>
                            <img src="images/home/checkmark.png" style={{width:'24px'}}/> Current teachers
                        </h3>
                        <h3>
                            <img src="images/home/checkmark.png" style={{width:'24px'}}/> Second year or later Uni. students with a High GPA
                        </h3>
                        <h3>
                            <img src="images/home/checkmark.png" style={{width:'24px'}}/> Perfect for final essay drafts or non-term assignments
                        </h3>
                        <h2>From $7/page (325 words)</h2>
                        <a href="/get-started">
                            <div className="get-started-btn get-started-blue get-started-small text-center large-12">
                            EDIT MY PAPER NOW!
                            </div>
                        </a>
                    </div>
                    <div className="large-12 columns" style={{clear: 'both'}}>
                        <div style={{height:'92px'}}></div>
                        <h1 className="text-center">WHO ARE THE EDITORS?</h1>
                        <div style={{height:'32px'}}></div>
                        <div className="whoareEditors">
                            <div className="whoare">
                                <img src="images/home/checkmark.png"/>
                                <h6>University Graduates &amp; PhD Editors</h6>
                            </div>
                            <div className="whoare">
                                <img src="images/home/checkmark.png"/>
                                <h6>Professors &amp; Teaching Assistants</h6>
                            </div>
                            <div className="whoare">
                                <img src="images/home/checkmark.png"/>
                                <h6>Experienced Teachers</h6>
                            </div>
                            <div className="whoare">
                                <p><a href="/edit-tiers" style={{"fontFamily":"Quicksand Bold","paddingLeft":"10%","textDecoration":"underline"}}>See what our editors can do for you</a></p>
                            </div>
                        </div>
                        <div className="seal">
                            <center>
                                <img src="images/home/seal.png" style={{maxWidth:'100%'}}/>
                            </center>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default connect(
)(EditTiersSection);


// WEBPACK FOOTER //
// ./src/components/pages/home/EditTiersSection.js